// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import chevronSelectorVerticalIcon from "@/assets/icons/chevron-selector-vertical.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ChevronSelectorVerticalIconProps = Omit<IconProps, "name">;

export function ChevronSelectorVerticalIcon(props: ChevronSelectorVerticalIconProps): React.ReactNode {
  return <Icon name={chevronSelectorVerticalIcon} {...props} />;
}
